class CollectionGridEditorialImages {
	constructor(grid) {
		this.grid = grid;
		this.timer = null;
		this.observer = new MutationObserver(() => this.scheduleRefresh());
		this.observer.observe(this.grid, { childList: true });
		this.scheduleRefresh();
	}

	scheduleRefresh() {
		window.clearTimeout(this.timer);
		this.timer = window.setTimeout(() => this.refresh(), 250);
	}

	refresh() {
		const cards = Array.from(this.grid.children).filter((item) =>
			item.matches('li.column:not(.collection-grid-image):not(.promotion-column)')
		);
		if (!cards.length) return;

		this.observer.disconnect();
		this.grid.querySelectorAll(':scope > .collection-grid-image').forEach((image) => image.remove());

		this.insert('first', cards[3], 'after');
		this.insert('second', cards[Math.max(0, cards.length - 2)], 'before');

		this.observer.observe(this.grid, { childList: true });
	}

	insert(slot, target, position) {
		if (!target) return;
		const templates = this.grid.parentElement.querySelector('.collection-grid-editorial-templates');
		if (!templates) return;
		const page = templates.dataset.currentPage;
		const template = templates.querySelector(
			`template[data-editorial-page="${page}"][data-editorial-slot="${slot}"]`
		);
		if (!template) return;
		target[position](template.content.cloneNode(true));
	}
}

function initializeCollectionGridEditorialImages() {
	document.querySelectorAll('.collection-product-grid-alt').forEach((grid) => {
		if (grid.dataset.editorialImagesInitialized) return;
		grid.dataset.editorialImagesInitialized = 'true';
		new CollectionGridEditorialImages(grid);
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeCollectionGridEditorialImages);
} else {
	initializeCollectionGridEditorialImages();
}

window.initCollectionGridEditorialImages = initializeCollectionGridEditorialImages;
